import { render } from "./BaseInputMessage.vue?vue&type=template&id=3b188704&scoped=true"
import script from "./BaseInputMessage.vue?vue&type=script&lang=js"
export * from "./BaseInputMessage.vue?vue&type=script&lang=js"

import "./BaseInputMessage.vue?vue&type=style&index=0&id=3b188704&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b188704"]])

export default __exports__